/*eslint-disable*/
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
} from 'reactstrap';

// import images
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import envisionLogo from '../assets/images/envision-logo-lg.png';

// import Components
import ProfileDropdown from '../components/Common/ProfileDropdown';

import { changeSidebarVisibility } from '../slices/thunks';
import CurrentCompany from '../components/Common/CurrentCompany';
import { withBase } from '../utils/route.util';

function Header({ headerClass }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectDashboardData = createSelector(
    state => state.Layout.sidebarVisibilitytype,
    sidebarVisibilitytype => sidebarVisibilitytype,
  );
  // Inside your component
  const sidebarVisibilitytype = useSelector(selectDashboardData);

  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };

  const toogleMenuBtn = () => {
    const windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility('show'));

    if (windowSize > 767) {
      document.querySelector('.hamburger-icon').classList.toggle('open');
    }

    // For collapse horizontal menu
    if (document.documentElement.getAttribute('data-layout') === 'horizontal') {
      if (document.body.classList.contains('menu')) {
        document.body.classList.remove('menu');
      } else {
        document.body.classList.add('menu');
      }
    }

    // For collapse vertical and semibox menu
    if (
      sidebarVisibilitytype === 'show' &&
      (document.documentElement.getAttribute('data-layout') === 'vertical' ||
        document.documentElement.getAttribute('data-layout') === 'semibox')
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove('vertical-sidebar-enable');
        if (
          document.documentElement.getAttribute('data-sidebar-size') === 'sm'
        ) {
          document.documentElement.setAttribute('data-sidebar-size', '');
        } else {
          document.documentElement.setAttribute('data-sidebar-size', 'sm');
        }
      } else if (windowSize > 1025) {
        document.body.classList.remove('vertical-sidebar-enable');
        if (
          document.documentElement.getAttribute('data-sidebar-size') === 'lg'
        ) {
          document.documentElement.setAttribute('data-sidebar-size', 'sm');
        } else {
          document.documentElement.setAttribute('data-sidebar-size', 'lg');
        }
        // document.documentElement.getAttribute('data-sidebar-size') === 'lg'
        //   ? document.documentElement.setAttribute('data-sidebar-size', 'sm')
        //   : document.documentElement.setAttribute('data-sidebar-size', 'lg');
      } else if (windowSize <= 767) {
        document.body.classList.add('vertical-sidebar-enable');
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
    }

    // Two column menu
    if (document.documentElement.getAttribute('data-layout') === 'twocolumn') {
      if (document.body.classList.contains('twocolumn-panel')) {
        document.body.classList.remove('twocolumn-panel');
      } else {
        document.body.classList.add('twocolumn-panel');
      }
    }
  };

  const getDashboardLink = () => {
    const { pathname } = window.location;
    if (pathname.includes('/hr')) {
      return withBase('/hr/dashboard');
    }
    return withBase('/dashboard');
  };

  return (
    <header id="page-topbar" className={headerClass}>
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={envisionLogo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={envisionLogo} alt="" height="17" />
                </span>
              </Link>
              <Link to={getDashboardLink()} className="logo logo-light">
                <span className="logo-sm">
                  <img src={envisionLogo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={envisionLogo} alt="" height="17" />
                </span>
              </Link>
            </div>
            <button
              hidden
              onClick={toogleMenuBtn}
              type="button"
              className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
              id="topnav-hamburger-icon"
              aria-label="Toggle menu"
            >
              <span className="hamburger-icon">
                <span />
                <span />
                <span />
              </span>
            </button>
          </div>

          <div className="d-flex align-items-center">
            <Dropdown
              isOpen={search}
              toggle={toogleSearch}
              className="d-md-none topbar-head-dropdown header-item"
            >
              <DropdownToggle
                type="button"
                tag="button"
                className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
              >
                <i className="bx bx-search fs-22" />
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                <Form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <button
                        className="btn custom-btn"
                        type="submit"
                        aria-label="Search"
                      >
                        <i className="mdi mdi-magnify" />
                      </button>
                    </div>
                  </div>
                </Form>
              </DropdownMenu>
            </Dropdown>

            <Button
              title="Access frequently asked questions and helpful guides about using the platform."
              onClick={() => navigate('/faq')}
              className="btn-icon me-2"
              style={{
                backgroundColor: '#F2F4F7',
                border: '1px solid #D0D5DD',
                color: '#475467',
                borderRadius: '11px',
                padding: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <span className="mdi mdi-help-circle-outline" />
            </Button>
            <CurrentCompany />
            <ProfileDropdown />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
